module.exports = __webpack_public_path__ + "img/icon-devices.5312378a.png";